import React from "react";
import TableHeader from "./tableHeader";
import TableBody from "./tableBody";

const Table = ({ columns, sortColumn, onSort, data, cardStyle = true }) => {
  return (
    <div className="table-responsive">
      <table className={`table table-hover table-sm ${cardStyle ? 'table-cards' : ''}`}>
        <TableHeader columns={columns} sortColumn={sortColumn} onSort={onSort} />
        <TableBody columns={columns} data={data} />
      </table>
    </div>
  );
};

export default Table;
